var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('aside',{class:['sidebar-container', {'is-collapse': _vm.isCollapse}]},[_vm._t("default",[_c('sidebar')])],2)}
var staticRenderFns = []

export { render, staticRenderFns }